import axios from 'axios';

export class BlockUsersService {
  static async requestForBlockContacts() {
    const url = '/p/contact/v2/worksAt/block/list?' + new Date().getTime();
    try {
      const resp = await axios.get(url);
      if (resp.status === 200) {
        return [null, resp.data];
      } else {
        return [resp.status, null];
      }
    } catch (error) {
      return [-1, null];
    }
  }

  static async unblockingExternalContacts(worksAtContactNo) {
    const resp = await axios.post(
      '/p/contact/v2/worksAt/block/unset',
      'worksAtContactNo=' + worksAtContactNo,
      { serialize: true },
    );
    if (resp.status !== 200) {
      return null;
    } else {
      return resp.data;
    }
  }
}
